import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

interface Venue {
  id: string;
  name: string;
  slug: string;
  description?: string;
  subscriptionTier: 'free' | 'basic' | 'pro';
}

interface VenueResponse {
  success: boolean;
  data: Venue;
}

export function useVenue(venueId: string | null | undefined) {
  return useQuery({
    queryKey: ["venue", venueId],
    queryFn: async () => {
      const response = await apiGet<VenueResponse>(`/venues/${venueId}`);
      return response.data;
    },
    enabled: !!venueId,
  });
}
